import { motion } from "framer-motion";

interface BuiltForCarouselProps {
  items: string[];
  eyebrow?: string;
  heading?: string;
}

const BuiltForCarousel = ({ items, eyebrow, heading }: BuiltForCarouselProps) => {
  return (
    <div className="relative z-10 pb-8 sm:pb-12 pt-12 sm:pt-0">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
      >
        {eyebrow && (
          <p className="text-xs font-body font-medium tracking-widest text-muted-foreground text-center mb-5">
            {eyebrow}
          </p>
        )}

        {heading && (
          <h2 className="text-3xl sm:text-4xl font-display tracking-tight text-center mb-8">
            {heading}
          </h2>
        )}

        {/* Mobile: chip grid */}
        <div className="sm:hidden px-4">
          <div className="flex flex-wrap justify-center gap-2">
            {items.map((name) => (
              <span
                key={name}
                className="text-xs font-body text-soft-foreground font-medium whitespace-nowrap px-3 py-1.5 rounded-full border border-border/50 bg-card/30"
              >
                {name}
              </span>
            ))}
          </div>
        </div>

        {/* Desktop: infinite marquee */}
        <div className="hidden sm:block relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-background to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-background to-transparent z-10" />
          <div className="flex animate-marquee">
            {[...items, ...items, ...items, ...items].map((name, i) => (
              <span key={i} className="flex-shrink-0 flex items-center gap-6 mx-0">
                <span className="text-sm font-body text-muted-foreground font-medium whitespace-nowrap px-3">
                  {name}
                </span>
                <span className="text-primary/40 text-[10px]">◆</span>
              </span>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default BuiltForCarousel;
